// extracted by mini-css-extract-plugin
export default {"line_inquiry":"NKnT8g1eyBF1WuqvVvVQ","lineInquiry":"NKnT8g1eyBF1WuqvVvVQ","bolder":"dF1YkZS1b3OSESz7FzE2"};